import { forwardRef, type MouseEventHandler, type ReactNode } from 'react';
import MuiIconButton from '@mui/material/IconButton';
import type { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type IconButtonColor = 'primary' | 'secondary' | 'warning' | 'info';
export type IconButtonVariant = NonNullable<MuiButtonProps['variant']>;
export type IconButtonShape = 'square' | 'circle';

export type IconButtonProps = {
  children?: ReactNode;
  color?: IconButtonColor;
  variant?: IconButtonVariant;
  /** @default 'square' */
  shape?: IconButtonShape;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  onClick?: MouseEventHandler<HTMLButtonElement>;
  'aria-label'?: string;
};

/** Thin wrapper around MUI IconButton with design-system color and variant. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  {
    color = 'primary',
    variant = 'contained',
    shape = 'square',
    children,
    disabled,
    size = 'medium',
    onClick,
    'aria-label': ariaLabel
  },
  ref
) {
  return (
    <MuiIconButton
      ref={ref}
      disabled={disabled}
      size={size}
      onClick={onClick}
      aria-label={ariaLabel}
      disableRipple={variant === 'text'}
      className={[
        'SmIconButton-root',
        `SmIconButton-color-${color}`,
        `SmIconButton-variant-${variant}`,
        `SmIconButton-shape-${shape}`
      ].join(' ')}
    >
      {children}
    </MuiIconButton>
  );
});
